import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-things-to-avoid',
  templateUrl: './things-to-avoid.component.html',
  styleUrls: ['./things-to-avoid.component.css']
})
export class ThingsToAvoidComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/main/things-to-avoid/things-to-avoid.component.ts